/**
 * Extension (lower-case, no dot) to MIME type, for files the OS hands over with an empty File.type.
 * Hosts accepting other types must extend this map, or extensionless-MIME files of those types are rejected.
 */
const EXTENSION_MIME: Readonly<Record<string, string>> = {
    pdf: 'application/pdf',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    webp: 'image/webp',
    mp4: 'video/mp4',
    mov: 'video/quicktime',
    avi: 'video/x-msvideo',
};

/** Non-standard MIME names some platforms report (e.g. Windows registers .avi as video/avi), mapped to the registered type. */
const MIME_ALIAS: Readonly<Record<string, string>> = {
    'video/avi': 'video/x-msvideo',
    'video/msvideo': 'video/x-msvideo',
};

/** What a browser reports when it does not know the type; treated like an empty File.type. */
const UNKNOWN_MIME = 'application/octet-stream';

/** File.type (aliases normalized), or the MIME implied by the extension when the OS supplied none or only UNKNOWN_MIME ('' when neither). */
export function EffectiveFileType(f: Pick<File, 'name' | 'type'>): string {
    if (f.type !== '' && f.type !== UNKNOWN_MIME) return MIME_ALIAS[f.type] ?? f.type;
    const dot = f.name.lastIndexOf('.');
    return dot < 0 ? '' : (EXTENSION_MIME[f.name.slice(dot + 1).toLowerCase()] ?? '');
}
